import { useState } from "react";
import { Card, PageHeader, Input, Select, Btn, Table, Modal, StatusBadge } from "../../components/shared/UIComponents";

export function CreateTickets() {
  return (
    <Card>
      <PageHeader title="Help Desk Tickets" />
      <div style={{ padding: 24 }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
          <Input label="Ticket No" defaultValue="TN39706" />
          <Input label="Complaint Date" type="date" />
          <div style={{ gridColumn: "span 2" }}><Input label="Title" placeholder="Enter Title" /></div>
          <div style={{ gridColumn: "span 2" }}>
            <label style={{ display: "block", fontSize: 11, fontWeight: 600, color: "#78909c", marginBottom: 5, textTransform: "uppercase" }}>Issue Description</label>
            <textarea placeholder="Enter Issue Description" style={{ width: "100%", padding: "9px 12px", border: "1.5px solid #e0e0e0", borderRadius: 8, fontSize: 13, boxSizing: "border-box", height: 80 }} />
          </div>
          <Select label="Helpdesk Categories" options={["Select", "Lift Maintenance Issues", "Data Correction", "Common Facility Usage", "Housekeeping Issues", "Gardening Problem", "Security Related Issues", "Parking Problem", "Office Administration", "Electricity Issues", "CCTV Camera not working", "Online Payment Issues", "Suggestions", "Water Related Problm", "Billing Accounts Not proper", "Bill Related Issues"]} />
          <Input label="Committee Members" placeholder="Select Committee Member" />
          <Input label="Select Vendor" placeholder="Select Vendor" />
          <Select label="Select Flat" options={["Select", "F0102 - Abhishek Singh", "F0103 - Ashok Kumar", "F0104 - Sohail V Bhagat"]} />
          <div style={{ gridColumn: "span 2" }}>
            <label style={{ display: "block", fontSize: 11, fontWeight: 600, color: "#78909c", marginBottom: 5, textTransform: "uppercase" }}>File Upload</label>
            <input type="file" style={{ fontSize: 13, padding: "7px", border: "1.5px solid #e0e0e0", borderRadius: 8 }} />
          </div>
          <div style={{ gridColumn: "span 2", display: "flex", gap: 10 }}><Btn>Save</Btn><Btn bg="#42a5f5">Refresh</Btn></div>
        </div>
      </div>
    </Card>
  );
}

export function ViewTickets() {
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [logTicket, setLogTicket] = useState(null);
  const tickets = [
    { no: "TN18234", flat: "F0202", issue: "CCTV Camera not working", status: "Closed", date: "2025-09-09", att: "68bfd78d1cf0e.pdf" },
    { no: "TN20838", flat: "F0202", issue: "Internet issue in common area", status: "New", date: "2025-09-09", att: "68bfd77314b4e.pdf" },
    { no: "TN22891", flat: "F0202", issue: "Lift maintenance required", status: "New", date: "2025-09-09", att: "68bfd6a84ab46.pdf" },
    { no: "TN25853", flat: "F0102", issue: "Parking Problem", status: "InProgress", date: "2025-08-20", att: "68a5652c53ff2.jpg" },
    { no: "TN45852", flat: "F0202", issue: "Water Leakage", status: "New", date: "2025-09-09", att: "68bfd7f905e2e.pdf" },
    { no: "TN47617", flat: "F0202", issue: "Street light not working", status: "New", date: "2025-09-09", att: "68bfd74a89b5b.pdf" },
    { no: "TN67764", flat: "F0202", issue: "Garbage collection delay", status: "New", date: "2025-09-09", att: "68bfd728a1c4b.jpg" },
  ];
  const logData = [
    { d: "2025-09-18", st: "InProgress", r: "", by: "sc@123", ad: "2025-09-18" },
    { d: "2025-09-26", st: "InProgress", r: "", by: "sc@123", ad: "2025-09-26" },
    { d: "2025-10-03", st: "Closed", r: "Resolved", by: "sc@123", ad: "2025-10-03" },
  ];
  return (
    <Card>
      <PageHeader title="Manage Complaints" />
      <div style={{ padding: 16 }}>
        <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
          <Btn bg="#607d8b" style={{ padding: "7px 14px", fontSize: 12 }}>Copy</Btn>
          <Btn bg="#0f9d58" style={{ padding: "7px 14px", fontSize: 12 }}>Excel</Btn>
          <Btn bg="#1565c0" style={{ padding: "7px 14px", fontSize: 12 }}>Column visibility</Btn>
          <div style={{ marginLeft: "auto" }}><input placeholder="Search..." style={{ padding: "7px 12px", border: "1.5px solid #e0e0e0", borderRadius: 8, fontSize: 13 }} /></div>
        </div>
        <Table columns={["Complain No", "FlatNo", "Issue Desc", "Status", "Dated", "Attachment", "Update", "Log", "Delete"]} rows={tickets}
          renderRow={(r) => [
            <td style={{ padding: "9px 12px", fontWeight: 600, color: "#1565c0" }}>{r.no}</td>,
            <td style={{ padding: "9px 12px" }}>{r.flat}</td>,
            <td style={{ padding: "9px 12px" }}>{r.issue}</td>,
            <td style={{ padding: "9px 12px" }}><StatusBadge status={r.status} /></td>,
            <td style={{ padding: "9px 12px", color: "#78909c" }}>{r.date}</td>,
            <td style={{ padding: "9px 12px" }}>{r.att ? <a href="/" style={{ color: "#1565c0", fontSize: 12 }}>{r.att}</a> : ""}</td>,
            <td style={{ padding: "9px 12px" }}><button onClick={() => setSelectedTicket(r)} style={{ background: "#1565c0", color: "#fff", border: "none", borderRadius: 5, padding: "4px 10px", cursor: "pointer", fontSize: 12, fontWeight: 600 }}>Update</button></td>,
            <td style={{ padding: "9px 12px" }}><button onClick={() => setLogTicket(r)} style={{ background: "#0f9d58", color: "#fff", border: "none", borderRadius: 5, padding: "4px 10px", cursor: "pointer", fontSize: 12, fontWeight: 600 }}>View</button></td>,
            <td style={{ padding: "9px 12px" }}><button style={{ background: "#fce8e6", border: "none", borderRadius: 5, padding: "4px 8px", cursor: "pointer", fontSize: 12 }}>🗑️</button></td>,
          ]}
        />
      </div>
      {selectedTicket && (
        <Modal title={`TICKET NO: ${selectedTicket.no} – ${selectedTicket.issue}`} onClose={() => setSelectedTicket(null)}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8, marginBottom: 16, fontSize: 13 }}>
            <div><strong>Complaint Date:</strong> {selectedTicket.date}</div>
            <div><strong>Category:</strong> Maintenance</div>
            <div><strong>Flat No:</strong> {selectedTicket.flat}</div>
          </div>
          <div style={{ fontSize: 13, marginBottom: 16 }}><strong>Description:</strong> {selectedTicket.issue}</div>
          {selectedTicket.att && <div style={{ fontSize: 13, marginBottom: 16 }}><strong>File:</strong> <a href="/" style={{ color: "#1565c0" }}>{selectedTicket.att}</a></div>}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, marginBottom: 16 }}>
            <Select label="Status" options={["New", "InProgress", "Closed"]} />
            <Input label="Resolved Dated" type="date" />
            <div style={{ gridColumn: "span 2" }}>
              <label style={{ display: "block", fontSize: 11, fontWeight: 600, color: "#78909c", marginBottom: 5, textTransform: "uppercase" }}>Remarks</label>
              <textarea style={{ width: "100%", padding: "9px 12px", border: "1.5px solid #e0e0e0", borderRadius: 8, fontSize: 13, boxSizing: "border-box", height: 70 }} />
            </div>
          </div>
          <div style={{ display: "flex", gap: 10 }}>
            <Btn bg="#0f9d58">Update</Btn>
            <Btn bg="#607d8b" onClick={() => setSelectedTicket(null)}>Close</Btn>
          </div>
        </Modal>
      )}
      {logTicket && (
        <Modal title="Ap IT Services - Ticket Log" onClose={() => setLogTicket(null)}>
          <div style={{ textAlign: "center", marginBottom: 16 }}>
            <div style={{ fontWeight: 700, color: "#1a2744" }}>Ap IT Services</div>
            <div style={{ fontSize: 12, color: "#607d8b" }}>Complaint: {logTicket.issue} on {logTicket.date}</div>
          </div>
          <Table columns={["SrNo", "Status Dated", "Status", "Remarks", "Added By", "Added Date"]} rows={logData}
            renderRow={(r, i) => [
              <td style={{ padding: "8px 10px" }}>{i + 1}</td>,
              <td style={{ padding: "8px 10px" }}>{r.d}</td>,
              <td style={{ padding: "8px 10px" }}><StatusBadge status={r.st} /></td>,
              <td style={{ padding: "8px 10px" }}>{r.r}</td>,
              <td style={{ padding: "8px 10px" }}>{r.by}</td>,
              <td style={{ padding: "8px 10px" }}>{r.ad}</td>,
            ]}
          />
          <div style={{ textAlign: "right", marginTop: 16 }}><Btn bg="#607d8b" onClick={() => setLogTicket(null)}>Close</Btn></div>
        </Modal>
      )}
    </Card>
  );
}

export default CreateTickets;
